import React, { useContext } from "react";
import UIVote from "ui/UIVote";
import UIPersonaFlag from "ui/UIPersonaFlag";
import ButtonDropDown from "ui/Dropdown/buttonDropDown";

import DatabaseContext from "data/contextDatabase";
import { useHistory } from "react-router-dom";

const dateFormat = (s) => {
  const d = new Date(s + "-0000");
  return d.toLocaleString();
};

const strToImage = (i) => {
  return i;
};

const timestamp = (pref1, pref2, pref3) => {
  if (pref1 && pref1 !== "") {
    return pref1;
  } else if (pref2 && pref2 !== "") {
    return pref2;
  } else if (pref3 && pref3 !== "") {
    return pref3;
  }
  return "";
};

const left_or_right = (props) => {
  let side = props.message.mpersona === props.you ? "right" : "left";
  if (props.message.parameters?.reverse_side === "true")
    side = props.message.mpersona === props.you ? "left" : "right";
  switch (props.message.parameters?.side) {
    case "reverse":
      side = props.message.mpersona === props.you ? "left" : "right";
      break;
    case "left":
      side = "left";
      break;
    case "right":
      side = "right";
      break;
    default: {
      break;
    }
  }
  return side;
};

const sortJoin = (A, B, Delim) => {
  return A < B ? A + Delim + B : B + Delim + A;
};

const UIMessage = (props) => {
  const { databaseState, databaseDispatch } = useContext(DatabaseContext);
  let history = useHistory();

  const menuClick = () => {
    alert("Hi");
  };

  const menuClick2 = () => {
    alert("Bye");
  };

  const menuClickDialog = () => {
    console.log(
      "addDialog = ",
      props.muid,
      props.you,
      props.persona,
      props.message.mpersona,
      props.message.persona
    );
    let d = {
      dialog: props.message.persona,
      got_voice: true,
      mdialog: sortJoin(props.you, props.message.mpersona, "_"),
      mpersona: props.you,
      persona: props.persona,
      peer: props.message.mpersona,
      peerpersona: props.message.persona,
      // topic_display_name: "",
      visibility: "PRIVATE_DIALOG",
    };
    databaseDispatch({
      type: "UPSERT_REC",
      values: {
        db: databaseState.dbMaster,
        collection: "dialog",
        table: props.muid,
        rowid: sortJoin(props.you, props.message.mpersona, "_"),
        doc: d,
      },
    });
    history.push("/UIMessageList", {
      dialog: d,
    });
  };

  const menuItems = [
    !!(props.message?.parameters?.allow_whisper !== "false") && {
      text: "Whisper",
      callback: menuClick,
    },
    { text: "Private chat", callback: menuClickDialog },
    { text: "Report user", callback: menuClick },
    { text: "Block user", callback: menuClick2 },
  ];

  const isColour = (colour) =>
    colour && colour.startsWith("#") && colour.length < 8;
  const bubbleColour = (bubbcolor) => (isColour(bubbcolor) ? bubbcolor : "");
  const textColour = (bubbcolor) =>
    isColour(bubbcolor)
      ? "#" + contrastingColor(bubbcolor.replace("#", ""))
      : "";

  const contrastingColor = (color) => {
    return luma(color) >= 135 ? "000" : "fff";
  };
  const luma = (
    color // color can be a hx string or an array of RGB values 0-255
  ) => {
    var rgb = typeof color === "string" ? hexToRGBArray(color) : color;
    return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]; // SMPTE C, Rec. 709 weightings
  };
  const hexToRGBArray = (color) => {
    if (color.length === 3)
      color =
        color.charAt(0) +
        color.charAt(0) +
        color.charAt(1) +
        color.charAt(1) +
        color.charAt(2) +
        color.charAt(2);
    else if (color.length !== 6) throw "Invalid hex color: " + color;
    var rgb = [];
    for (var i = 0; i <= 2; i++) rgb[i] = parseInt(color.substr(i * 2, 2), 16);
    return rgb;
  };

  const strAvatar = props.message.persona.substring(0, 2).toUpperCase();

  let content = (
    <div
      className="UI-message"
      type={left_or_right(props)}
      style={{
        backgroundColor: bubbleColour(props.message?.parameters?.bubbcolor),
      }}
    >
      <div className="avatar-frame">
        {props.message.persona_picture !== "" ? (
          <img
            className="avatar"
            src={
              props.message.persona_picture === ""
                ? ""
                : "data:image/png;base64," + props.message.persona_picture
            }
            alt={props.message.persona}
          />
        ) : (
          <div className="avatar-string">{strAvatar}</div>
        )}
        {!!(props.message?.parameters?.show_menu !== "false") && (
          <ButtonDropDown
            className=".UI-buttondropdown"
            menuItems={menuItems}
          />
        )}

        <UIPersonaFlag mpersona={props.message.mpersona} />
      </div>
      <div className="content">
        <p
          className="name"
          style={{ color: textColour(props.message?.parameters?.bubbcolor) }}
        >
          {props.message.name}
        </p>

        {props.message.thumbnail !== "" && (
          <img
            className="thumbnail"
            src={"data:image/png;base64," + props.message.thumbnail}
            alt={props.message.name}
          />
        )}
        <p
          style={{
            whiteSpace: "pre-wrap",
            color: textColour(props.message?.parameters?.bubbcolor),
          }}
        >
          {props.message.content.body}
        </p>
        {props &&
        props.message &&
        props.message.parameters &&
        props.message.parameters.choices ? (
          <UIVote
            message={props.message}
            persona={props.persona}
            mpersona={props.you}
            muid={props.muid}
          />
        ) : (
          <div></div>
        )}
        <p
          className={
            left_or_right(props) === "right" ? "time-right" : "time-left"
          }
          style={{ color: textColour(props.message?.parameters?.bubbcolor) }}
        >
          {dateFormat(
            timestamp(
              props.message.ts_server,
              props.message.ts_origin_server,
              props.message.ts_sender
            )
          )}
        </p>
      </div>
    </div>
  );

  return content;
};

export default React.memo(UIMessage, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
